import { render, staticRenderFns } from "./DocumentAddIcon.vue?vue&type=template&id=003ceb5e&"
import script from "./DocumentAddIcon.vue?vue&type=script&lang=js&"
export * from "./DocumentAddIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports